import { VanMovelResponse } from "../interface/vanMovel";

const API_KEY = "AkXc:gt_a/#Nd1f6b@&S/9Nq2hBiqy!N*((s5:*y8;3,53T)^H";
const BASE_URL = "https://api-pb-landingpage-prd.azurewebsites.net";

export async function getVanMovelData(idSubBrand: number): Promise<VanMovelResponse> {
  try {
    const response = await fetch(
      `${BASE_URL}/api/get-data/van-movel-toyota?id_sub_brand=${idSubBrand}`,
      {
        headers: {
          "x-api-key": API_KEY,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Falha ao buscar dados da Van Móvel");
    }

    return await response.json();
  } catch (error) {
    console.error("Erro ao buscar dados da Van Móvel:", error);
    return { data: [], meta: { total: 0 } };
  }
}
